<template>
  <nuxt-error-boundary @error="() => {}">
    <Swiper
      :modules="[SwiperAutoplay, SwiperEffectCreative, SwiperPagination]"
      :slides-per-view="1"
      :loop="true"
      :pagination="{
        clickable: true,
        bulletActiveClass: '!bg-white',
        renderBullet: (_index, className) => {
          return (
            `<span class='` +
            className +
            ` !w-3 !h-3 !mb-[22px] !bg-gray-30 !opacity-100'></span>`
          )
        }
      }"
      :autoplay="{
        delay: 6000,
        disableOnInteraction: true
      }"
      :creative-effect="{
        prev: {
          shadow: false,
          translate: ['-20%', 0, -1]
        },
        next: {
          translate: ['100%', 0, 0]
        }
      }"
    >
      <SwiperSlide v-for="(slide, index) in pageData" :key="index">
        <ArticleLinkComponent
          :title-en="slide.titleEn"
          :title-th="slide.titleTh"
          :description-en="slide.descriptionEn"
          :description-th="slide.descriptionTh"
          :button-title-en="slide.primaryButtonEn"
          :button-title-th="slide.primaryButtonTh"
          :url="slide.primaryButtonHref"
          :image="slide.imageUrl"
          :image-mobile="slide.imageMobileUrl"
        />
      </SwiperSlide>
    </Swiper>
  </nuxt-error-boundary>
</template>

<script lang="ts" setup>
import { cmsRepository } from '~/repository/cmsRepository'

const ArticleLinkComponent = defineAsyncComponent({
  loader: () => import('../components/ArticleLink.vue')
})

const { $serverApi } = useNuxtApp()
const cmsRepo = cmsRepository($serverApi)

const { data: pageData } = await useAsyncData<
  {
    titleEn: string
    titleTh: string
    descriptionEn: string
    descriptionTh: string
    imageUrl: string
    imageMobileUrl?: string
    primaryButtonEn: string
    primaryButtonTh: string
    primaryButtonHref: string
  }[]
>(
  'getLandingPageCollection',
  async () => {
    const response = await cmsRepo.getWidget('landing-page-collection')
    if (response.data.data.items) return response.data.data.items
    return null
  },
  { server: true }
)
</script>
